import { roomArea } from './customer-proposal.js';
/** Shared quantity basis: an aggregate or an override cannot bring excluded rooms back. */
export function scopedFloorArea(doc, areaId) {
    return Math.round(doc.assessment.rooms.filter(r => !r.out_of_scope && !r.is_void && !!(r.quoted_finish || r.flooring) && (!areaId || r.area_id === areaId)).reduce((n, r) => n + (roomArea(r) ?? 0), 0) * 100) / 100;
}
/** Floor areas and assessment requirements from only the rooms being quoted. */
export function accessoryFloorScopes(doc) {
    return doc.assessment.areas.map((area) => ({
        area_id: area.id, name: area.name,
        area_m2: scopedFloorArea(doc, area.id),
        underlay: area.underlay || doc.assessment.underlay,
    }));
}
//# sourceMappingURL=proposal-accessory-scope.js.map